<template>
    <v-dialog v-model="show" max-width="1000" persistent no-click-animation>
        <div class="UploadDataFileDialog">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('compareDataCollection') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <v-form v-model="formValid" ref="form" class="dialog-content">
                <DataTableCustom
                    :headers="headers"
                    :items="items"
                    :current-page="pagination.page"
                    :total-page="totalPage"
                    :total-items="totalItems"
                    :items-per-page="pagination.rowsPerPage"
                    @item-per-page-change="updateItemsPerPage"
                    @page-change="refresh"
                    style="position: relative"
                >
                    <template v-slot:key="props">
                        <div>
                            <div v-if="props.item['is_similar']" style="color: #66BB6A">
                                {{ props.item['key'] }}
                            </div>
                            <div style="color: #DE6F5F" v-else>
                                {{ props.item['key'] }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:action="props">
                        <div style="text-align: center">
                            <img src="/img/scenario/success.svg" alt="icon-success" style="transform: scale(1.1)"
                                 v-if="props.item['is_similar']">
                            <img src="/img/scenario/fail.svg" alt="icon-fail" style="transform: scale(1.1)" v-else>
                        </div>
                    </template>
                </DataTableCustom>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import FormFileMixin from '@/modules/fptai/mixins/FormFileMixin'
import DataTableCustom from '@/components/DataTableCustom'

export default {
    name: 'CompareDataCollectionDialog',
    mixins: [FormMixin, DialogMixin, FormFileMixin],
    components: {
        DataTableCustom,
    },
    props: {
        testcaseOld: Object,
        dataCollectionListNew: Object
    },
    data () {
        return {
            data: [],
            dataCollectionOld: null,
            dataCollectionNew: null,
            pagination: {
                page: 1,
                rowsPerPage: 10,
            },
            totalPage: 1,
            totalItems: 0,
            items: []
        }
    },
    computed: {
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: 'Key',
                    value: 'key',
                    type: 'custom'
                },
                {
                    text: 'Old Testcase',
                    value: 'old_test_case'
                },
                {
                    text: 'New Testcase',
                    value: 'new_test_case'
                },
                {
                    text: 'Compare',
                    value: 'action',
                    type: 'custom',
                    textAlign: 'center',
                }
            ])
        }
    },
    methods: {
        updateDataCollection () {
            this.dataCollectionOld = this.testcaseOld ? this.testcaseOld['data_collection'] : null
            this.dataCollectionNew = (this.testcaseOld && this.dataCollectionListNew) ? this.dataCollectionListNew[this.testcaseOld['test_id']] : null
            return true
        },
        compareTwoObject () {
            if (!this.dataCollectionOld || !this.dataCollectionNew) {
                return
            }
            let keyOld = Object.keys(this.dataCollectionOld)
            let keyNew = Object.keys(this.dataCollectionNew)
            let result = [...new Set([...keyOld, ...keyNew])]
            this.items = []
            for (let i = 0; i < result.length; i++) {
                let oldTestcase = this.dataCollectionOld[result[i]]
                let newTestcase = this.dataCollectionNew[result[i]]
                let similar = oldTestcase === newTestcase
                if (oldTestcase !== undefined && newTestcase !== undefined && similar) {
                    this.items.unshift({
                        'key': result[i],
                        'old_test_case': oldTestcase,
                        'new_test_case': newTestcase,
                        'is_similar': similar
                    })
                } else {
                    this.items.push({
                        'key': result[i],
                        'old_test_case': (oldTestcase === undefined) ? 'undefined' : oldTestcase,
                        'new_test_case': (newTestcase === undefined) ? 'undefined' : newTestcase,
                        'is_similar': similar
                    })
                }
            }
            this.data = this.items
        },
        updateItemsPerPage (newValue) {
            this.pagination.rowsPerPage = newValue
            this.refresh()
        },
        refresh (pager) {
            if (pager) {
                this.pagination.page = pager
            }
            this.totalItems = this.data.length
            this.totalPage = Math.ceil(this.totalItems / this.pagination.rowsPerPage)
            this.items = this.data.slice((this.pagination.page - 1) * this.pagination.rowsPerPage, this.pagination.page * this.pagination.rowsPerPage)
        },
        close () {
            this.show = false
            this.$emit('close')
        },
        open () {
            this.show = true
        },
    },
    watch: {
        testcaseOld: {
            deep: true,
            handler: function () {
                if (this.updateDataCollection()) {
                    this.compareTwoObject()
                    this.refresh()
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.UploadDataFileDialog {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .text-upload {
        font-size: 14px;
        padding: 12px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}

.test-area {
    height: calc(100vh - 400px);
    overflow-y: auto;
    background: #FFFFFF;
}

.title-col {
    background: #F7F9FD;
    border-right: 1px solid #E4EDFA;
    border-bottom: 1px solid #E4EDFA;
    height: 27px;
    font-family: "open sans semi";
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #617CA5;
    position: sticky;
    top: 0;
}


.message-container {
    min-height: calc(100vh - 430px);
    padding: 16px;
    font-family: "open sans";
    border: 1px solid #E4EDFA;
    border-top: none !important;
    font-size: 14px;


    .message-content {
        padding: 10px;
        border-radius: 5px;
        color: #fff;
        display: flex;
        align-items: center;
        line-height: 19px;

        &.bot {
            background: #0052CC;
        }

        &.user {
            background: #96ADD0;
        }
    }
}
</style>
